<template>
    <button
        @click="openSignInWithSlack"
        type="button"
        class="bg-white shadow w-full items-center content-center hover:bg-blue-100 focus:outline-none border-blue-500 border-2 text-lg font-semibold rounded-lg rounded-full text-center font-bold py-2 px-4 rounded inline-flex justify-center">
        <img
            src="/images/google-signin.svg"
            alt="slack logo" class="w-8 h-8 mr-2">
        <span>Sign in with Google</span>
    </button>
</template>

<script>
export default {
    components: {},
    data: function () {
        return {}
    },
    computed: {},
    methods: {
        openSignInWithSlack() {
            window.location.href = window.location.origin + '/auth/google';
        }
    },
    created() {
    },
    mounted() {
        console.log('Component mounted.')
    }
}
</script>

